module.exports = __webpack_public_path__ + "img/clock-sky.a648a3a7.png";